import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import {Grid} from "@material-ui/core";
import Dashboard from "./Dashboard";


const INITIAL_STATE = {
    open: false
};

class DashboardDialog extends React.Component {
    constructor(props) {

        super(props);

        this.state = INITIAL_STATE;
    }
    componentDidMount(){
        this.setState({ open: true })
    }

    handleCloseDialog = () => {
        this.setState({ open: false });
        this.props.handleCloseDialog();
    };

    render() {
        return (
            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth="xl"
                >
                    <DialogContent>
                        <Grid container
                              style={ {height: "90vh"}}>
                            <Grid item
                                  xs={12}
                                  style={{height: "100%", overflowY: "auto"}}>
                                <Dashboard dashboardUrl={this.props.dashboardUrl}/>
                            </Grid>
                        </Grid>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.handleCloseDialog}
                                variant="contained"
                                color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

DashboardDialog.propTypes = {
    dashboardUrl: PropTypes.string.isRequired,
    handleCloseDialog: PropTypes.func.isRequired
};

export default DashboardDialog;